// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1MBT9","list":"PatternAutocomplete_list__KK42Y"};